'use client';

import React__default, { useState, useEffect } from 'react';
import { ZaloWidgetContainer } from './styles.js';
import ZaloIcon from './ZaloIcon.js';

function ZaloWidget(_a) {
    var oaid = _a.oaid, className = _a.className;
    var _b = useState(false), isClient = _b[0], setIsClient = _b[1];
    var ZALO_LINK = "https://zalo.me/".concat(oaid);
    useEffect(function () {
        setIsClient(true);
    }, []);
    return isClient ? (React__default.createElement(ZaloWidgetContainer, { "aria-label": 'chat with vietnamworks', href: ZALO_LINK, target: '_blank', className: "zalo-widget ".concat(className) },
        React__default.createElement(ZaloIcon, { size: 44 }))) : null;
}

export { ZaloWidget as default };
//# sourceMappingURL=index.js.map
